import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import FormStack from 'components/FormStack';
import FormField from 'components/FormField';
import TextInput from 'components/TextInput';
import TextArea from 'components/TextArea';
import CheckboxOption from 'components/CheckboxOption';
function CollapsableMessageForm(_ref) {
  var subject = _ref.subject,
    message = _ref.message,
    handleSubmit = _ref.handleSubmit;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showForm = _useState2[0],
    setShowForm = _useState2[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CheckboxOption, {
    fontSize: "s",
    id: "showMessage",
    label: t('actions_add_personal_message'),
    checked: showForm,
    onChange: function onChange() {
      return setShowForm(!showForm);
    }
  }), showForm && /*#__PURE__*/React.createElement(FormStack, {
    mt: "s"
  }, /*#__PURE__*/React.createElement(FormField, {
    required: true,
    label: t('property_subject'),
    alert: subject.error
  }, /*#__PURE__*/React.createElement(TextInput, {
    value: subject.value,
    onChange: function onChange(e) {
      return subject.set(e.target.value);
    },
    onSubmit: handleSubmit
  })), /*#__PURE__*/React.createElement(FormField, {
    required: true,
    label: t('property_message'),
    alert: message.error
  }, /*#__PURE__*/React.createElement(TextArea, {
    maxRows: 8,
    value: message.value,
    onChange: function onChange(e) {
      return message.set(e.target.value);
    },
    onSubmit: handleSubmit
  }))));
}
export default CollapsableMessageForm;